var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.191 21.409a9.3 9.3 0 0 1-3.74-.757 9.7 9.7 0 0 1-3.046-2.057 9.7 9.7 0 0 1-2.057-3.046 9.3 9.3 0 0 1-.757-3.74q0-3.285 2.003-5.851t5.18-3.367a10.5 10.5 0 0 0 .496 4.67 10.25 10.25 0 0 0 2.49 3.978 10.25 10.25 0 0 0 3.98 2.49q2.26.774 4.669.497-.785 3.176-3.36 5.18-2.573 2.003-5.858 2.003m0-1.5a7.9 7.9 0 0 0 4.075-1.1 7.9 7.9 0 0 0 2.95-3.028 12.4 12.4 0 0 1-4.075-1.09 11.9 11.9 0 0 1-3.45-2.415A12.1 12.1 0 0 1 9.266 8.83a11.8 11.8 0 0 1-1.075-4.07A7.8 7.8 0 0 0 5.18 7.72 8.05 8.05 0 0 0 4.09 11.81q0 3.375 2.363 5.737t5.737 2.363"
  })));
};
export default SvgMoon;